const moduleName = "text.service";

const $inject = [];

class TextService {
  constructor() {
  }

  to_title_case(text) {
    let words = this.split(text);
    words = words.map(this.to_sentence_case);

    return words.join(' ');
  }

  to_sentence_case(text) {
    text = text.replace(/_/g, " ");
    text = text.charAt(0).toUpperCase() + text.slice(1);
    return text;
  }

  split(text) {
    // TODO Reinstate the "split uppercase after lowercase" rule without using a lookbehind for iOS compatibility (Only affects words like ThisHTMLPage)
    //return text.split(/ |-|_|(?<=[a-z])(?=[A-Z])|(?=[A-Z][a-z])/);
    return text.split(/ |-|_|(?=[A-Z][a-z])/);
  }
}

TextService.$inject = $inject;

export default angular.module(moduleName, [])
  .service("TextService", TextService)
  .name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/services/text.service.js
 **/